<script>
import ReportingApi from "@/services/reporting-api";
import CustomersApi from "@/services/customers-api";

export default {
    
    data(){
        return{
            

            alertsList: [],
            fields: [

                { key:"timestamp", label: "Date"},
                
                
                { key:"customer", label: "Client"},
                
                { key:"alertType", label: "Type"},
                                
                { key:"itemRef", label: "Référence"},
              
                
                
                ],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            selectedCustomer:null,
            start: null, //this.firstDay,
            end: null, //this.lastDay,
            isGetAlertsStarting:false,
            selectedItem: null,

            showDetailsModal : false,


            optionsAlertType:[{name:"Commandé, QUANTITE insuffisante", type:1}, {name:"Pas commandé, Article DISPO", type:2}, {name:"Pas Commandé, Article en RUPTURE", type:0}],
            selectedAlertType: null,


        }
    },
    methods:{
       
       getAlerts(){
            this.isGetAlertsStarting=true
            ReportingApi.getAlerts(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id, this.selectedAlertType == null ? null : this.selectedAlertType.type).then(
                (result) => {
                    if(result){
                        this.alertsList=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetAlertsStarting=false
            })
        },

        getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        },

    },
    mounted(){
      this.getCustomers()
      this.getAlerts()
    },

    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getAlerts()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getAlerts()
          }
        },

        selectedCustomer: function(){
            this.getAlerts()
        },

        selectedAlertType: function(){
            this.getAlerts()
        },
    }

}
</script>
<template>
   
   <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-primary">Alertes sur les Recherches Clients</h4>
        <div  class="row mt-4">
            <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"   label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12   ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>

        

        <div  class="row mt-0">
            <!-- <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div> -->

            <!-- <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 "></div> -->

            

            <div  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group >

                <v-select class="pb-2 font-size-16" :options="optionsAlertType" v-model="selectedAlertType" placeholder="Toutes les catégories d'Alertes" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 

                <!-- <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" placeholder="Types de réclamations" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select> -->
            </b-form-group>
            </div>

        </div>




        <div class="table-responsive mb-0" style="max-height:33em;min-height:33em"  >
            <b-table
            :busy="isGetAlertsStarting"
            :striped="true"
            :small="true"
            :hover="true"
            :items="alertsList"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>


            <template v-slot:cell(timestamp)="{value}">
                <span >{{value}}</span>
            </template>

            <template v-slot:cell(customer)="{value}">
                <span >{{value ? value : '-'}}</span>
            </template>

            <!-- <template v-slot:cell(username)="{item,value}">
                <span :class="item.isClosed ? 'text-muted' : 'font-weight-bold'">{{value}}</span>
            </template> -->

            <template v-slot:cell(alertType)="{item}">
                
                <b-badge class="mr-2 font-weight-bold" href="#" :variant="item.alertType ? item.alertType == 1 ? 'info' : 'warning' : 'secondary'">
                         {{item.alertType ? item.alertType == 1 ? 'CMD - QTE INSUFFISANTE' : 'PAS CMD - ARTICLE DISPONIBLE' : 'PAS CMD - ARTICLE RUPTURE'}} </b-badge>
            </template>

            <template v-slot:cell(itemRef)="{value}">
                <span>{{value}}</span>
            </template>
           
            <!-- <template v-slot:cell(alertType)="{item, value}">
                <h5>
                    <b-badge href="#" :variant="item.isClosed ? 'light' : !value ? 'warning' : 'danger'">
                         {{!value ? 'Référence introuvable' : value}}</b-badge>
                </h5>
            </template> -->

            <!-- <template v-slot:cell(details)="{item,value}"> 
                <i v-if="value" @click="showDetails(item)" style="cursor:pointer;"  class="mdi mdi-comment-text-multiple-outline text-warning text-right font-size-18 align-right"></i>
            </template> -->

            <!-- <template v-slot:cell(isClosed)="{item,value}"> 
                <i  @click="toggleAlertStatus(item)" style="cursor:pointer;" :class="value ? 'far fa-check-square text-muted'  : 'far fa-square text-warning' " class=" text-right font-size-18 align-right"></i>
            </template> -->

            <!-- <template v-slot:cell(filter)="{value}">
                {{!value ? "_" : value}}
            </template> -->
            
            </b-table>
            <span v-if="!isGetAlertsStarting && !alertsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }}</span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getAlerts()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getAlerts()" :disabled="isGetAlertsStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->


            <b-modal v-if="selectedItem"
                v-model="showDetailsModal"
                :title="' [' + selectedItem.itemRef + ']'"
                centered 
                hide-footer
                title-class="text-primary"
                title-tag="h5"
                hide-header
                header-close-variant="danger"
                size="md">
                
                

                <span class="text-warning font-weight-bold">Réclamation [{{selectedItem.itemRef}}] </span>
                <br/><span class="text-muted ">{{selectedItem.username}} {{selectedItem.customer ? ' - ' + selectedItem.customer : ''}}  </span>
                
                <textarea
                    v-model="selectedItem.details"
                    class="form-control mt-3"
                    :maxlength="250"
                    rows="3"
                    
                    ></textarea>

            </b-modal>

    </div>
</template>